export default () => ({
    formId: 1,
    form: null
})
